import { computed, inject, isSignal } from '@angular/core';

import { HrAssistantConfigDataService } from '@core/intelligence-logic';
import { provideHrAssistantFeature } from '@core/intelligence-smart-ui';
import { AskHrChatFeatureId } from '@tellent-ask-hr/core-types';
import { TicketsChatService } from '@tellent-ask-hr/tickets-logic';
import {
  ChatUserTicketsViewComponent,
  TicketsWelcomeComponent,
} from '@tellent-ask-hr/tickets-smart-ui';
import { injectPreviewAskEnabled } from '@tellent-intelligence/settings-contracts';

export const CHAT_TICKETS_LIST_FEATURE = provideHrAssistantFeature({
  useValue: {
    id: AskHrChatFeatureId.Tickets,
    welcomeCmp: TicketsWelcomeComponent,
    welcomeCmpVisible: () => {
      const hrAssistantConfigDataService = inject(HrAssistantConfigDataService);
      const ticketsChatService = inject(TicketsChatService);
      const askHrPreview = injectPreviewAskEnabled({ optional: true });
      hrAssistantConfigDataService.fetchIfNotLoaded();
      const ticketsFeatureAvailable = ticketsChatService.isFeatureAvailable();
      return computed(() => {
        if (!ticketsFeatureAvailable()) return false;

        return isSignal(askHrPreview)
          ? askHrPreview()
          : (hrAssistantConfigDataService.configData()?.ask.enabled ?? false);
      });
    },
    activateCmp: ChatUserTicketsViewComponent,
  },
});
